import { Injectable } from '@angular/core';
import { CompanyValueDTO } from '../../../AngularJS/Admin/Company/company.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class CompanySettingsService {
    companySettingsObj: any = {
        companyValues: [],
        valuesLoaded: false
    }

    constructor(
        private cvApiService: CVApiService,
    ) { }

    /**
     * 
     * @param fieldName Load company values by field name
     * @returns 
     */
    getCompanyValueByFieldName(fieldName: string) {
        if (!this.companySettingsObj.valuesLoaded) {
            return null;
        }
        else {
            const matches = this.companySettingsObj.companyValues.filter((itm: CompanyValueDTO) => itm.FieldName === fieldName);
            if (matches)
                return matches[0];
            else
                return null;
        }
    }

    /**
    * Loads data for a single company.
    * @param companyId ID of import to load data rows for.
    */
    async loadCompanyValues(companyId: number) {
        try {
            let response = await this.cvApiService.get<CompanyValueDTO[]>(`/api/v1/companyValues?companyId=${companyId}`);
            if (response.status_code >= 200 && response.status_code < 300) {
                this.companySettingsObj.companyValues = response.data;
                this.companySettingsObj.valuesLoaded = true;
            }
            else {
                throw response;
            }
        }
        catch (err) {
            console.error(`Failed to retrieve values for company ${companyId}.`);
            throw err;
        }
    }

    /**
* Loads data for the loggedIn company.
* No parameters
*/
    async loadLoggedInCompanyValues() {
        try {
            let response = await this.cvApiService.get<CompanyValueDTO[]>(`/api/v1/companyValues?companyId=${null}`);
            if (response.status_code >= 200 && response.status_code < 300) {
                this.companySettingsObj.companyValues = response.data;
                this.companySettingsObj.valuesLoaded = true;
            }
            else {
                throw response;
            }
        }
        catch (err) {
            console.error(`Failed to retrieve values for LoggedIn company.`);
            throw err;
        }
    }
}
